import React from "react";
import { Link } from "react-router-dom";
import {
  Sparkles,
  Building2,
  Truck,
  HardHat,
  AppWindow,
  Home as HomeIcon,
  Shirt,
  Droplets,
  Wind,
  Check,
  ArrowRight,
  Phone,
} from "lucide-react";
import { Button } from "../components/ui/button";
import Reveal from "../components/Reveal";
import { COMPANY, SERVICES_FULL } from "../mock";

const iconMap = { Sparkles, Building2, Truck, HardHat, AppWindow, Home: HomeIcon, Shirt, Droplets, Wind };

const Services = () => {
  return (
    <div>
      {/* HEADER */}
      <section className="relative overflow-hidden bg-gradient-to-b from-sky-50 to-white py-16 lg:py-20">
        <div className="pointer-events-none absolute -right-16 top-0 h-72 w-72 rounded-full bg-sky-200/40 blur-3xl animate-blob" />
        <Reveal className="relative mx-auto max-w-3xl px-5 text-center lg:px-8">
          <span className="text-sm font-semibold uppercase tracking-wider text-sky-600">Nos prestations</span>
          <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Comment pouvons-nous vous aider ?
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            Une gamme complète de services de nettoyage et d'entretien pour les
            particuliers et les professionnels — pensés pour vous faire gagner du
            temps et garantir un résultat impeccable.
          </p>
        </Reveal>
      </section>

      {/* SERVICE LIST */}
      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-6xl space-y-6 px-5 lg:px-8">
          {SERVICES_FULL.map((s, idx) => {
            const Icon = iconMap[s.icon];
            const reverse = idx % 2 === 1;
            return (
              <Reveal
                key={s.num}
                variant={reverse ? "right" : "left"}
                className="card-lift grid grid-cols-1 gap-8 rounded-3xl border border-slate-100 bg-white p-7 shadow-sm hover:shadow-xl lg:grid-cols-12 lg:p-10"
              >
                <div className={`lg:col-span-5 ${reverse ? "lg:order-2" : ""}`}>
                  <div className="flex items-center gap-4">
                    <span className="text-4xl font-extrabold text-sky-100">{s.num}</span>
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-500 text-white shadow-lg shadow-sky-500/25">
                      <Icon size={26} />
                    </div>
                  </div>
                  <h2 className="mt-5 text-2xl font-bold text-slate-900">{s.title}</h2>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600">{s.desc}</p>
                  <Link
                    to="/contact"
                    className="mt-6 inline-flex items-center gap-2 rounded-full bg-slate-900 px-6 py-2.5 text-sm font-semibold text-white transition-all hover:bg-sky-600"
                  >
                    Demander un devis pour ce service <ArrowRight size={16} />
                  </Link>
                </div>
                <div className={`lg:col-span-7 ${reverse ? "lg:order-1" : ""}`}>
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {s.points.map((p) => (
                      <div
                        key={p}
                        className="flex items-center gap-3 rounded-xl bg-sky-50/70 px-4 py-3.5 text-sm font-medium text-slate-700 transition-all duration-300 hover:bg-sky-100 hover:translate-x-1"
                      >
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-500 text-white">
                          <Check size={13} strokeWidth={3} />
                        </span>
                        {p}
                      </div>
                    ))}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="relative overflow-hidden bg-slate-900 py-16 lg:py-20">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_80%_30%,rgba(14,165,233,0.18),transparent_45%)]" />
        <Reveal className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
          <h2 className="text-3xl font-bold text-white sm:text-4xl">
            Une demande particulière ? Parlons-en.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-300">
            Chaque projet est unique. Décrivez-nous votre besoin et nous
            construisons une offre sur-mesure, claire et sans engagement.
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/contact">
              <Button className="btn-shine h-12 w-full rounded-full bg-sky-500 px-8 text-base font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-sky-600 sm:w-auto">
                Demander un devis
              </Button>
            </Link>
            <a href={`tel:${COMPANY.phoneRaw}`}>
              <Button
                variant="outline"
                className="h-12 w-full rounded-full border-2 border-slate-600 bg-transparent px-8 text-base font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-sky-400 sm:w-auto"
              >
                <Phone size={18} className="mr-2" /> {COMPANY.phone}
              </Button>
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
};

export default Services;
